import { Call, Email, FmdGood } from '@mui/icons-material'
export const contacts = [
  {
    icon: <Call />,
    title: 'Call',
    text: '+383 48 148557',
    href: 'tel:+38348148557',
  },
  {
    icon: <Email />,
    title: 'Mail',
    text: 'info@infogis.net',
    href: 'mailto:info@infogis.net',
  },
  {
    icon: <FmdGood />,
    title: 'Location',
    text: 'Dardani, Prishtina',
    href: 'https://goo.gl/maps/WFEv1jEL5oS5YwB3A',
  },
]
